import { render } from "./RefSource.vue?vue&type=template&id=84d81a92&scoped=true"
import script from "./RefSource.vue?vue&type=script&lang=js"
export * from "./RefSource.vue?vue&type=script&lang=js"

import "./RefSource.vue?vue&type=style&index=0&id=84d81a92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-84d81a92"]])

export default __exports__